import { DateBox, SelectBox, Template } from "devextreme-react";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import moment from "moment";
import DataGrid, {
  Column,
  Editing,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  Scrolling,
  SearchPanel,
} from "devextreme-react/data-grid";
import { DateFormat, RegEx } from "../../helpers/fixcodes";
import Modal from "react-modal";
import { axiosGet, axiosPost } from "../../apis/useAxios";
import { DataGridSkeletonPageSimple } from "../skeleton/GridSkeleton";
import { askConfirmation, showResponseMessage } from "../../helpers/message";

export default function HotelTransferContractComponent() {
  const [state, setState] = useState({
    loadPanelVisible: false,
    isViewHotelTransferContractModalOpen: false,
    isSaveHotelTransferContractModalOpen: false,
  });
  const [viewRowData, setViewRowData] = useState(null);
  const [editRowData, setEditRowData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [
    hotelTransferContractDataGridSource,
    setHotelTransferContractDataGridSource,
  ] = useState([]);
  const refDataGrid = useRef(null);

  useLayoutEffect(() => {
    document.querySelector(
      "#lblPageTitle"
    ).innerHTML = `Hotel Transfer Contract`;
  });

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnLoad = async () => {
    try {
      setTimeout(async () => {
        setIsLoading(true);
        await getHotelTransferContract();
        setIsLoading(false);
      }, 0);
    } catch (error) {
      console.log(error);
    }
  };

  const getHotelTransferContract = async () => {
    try {
      const response = await axiosPost(
        `/HotelTransferContract/get-contract-list`,
        {
          AirlineCode: sessionStorage.getItem("session_airlineCode"),
          AirportCode: "",
          HotelCode: "",
        }
      );
      setHotelTransferContractDataGridSource(response?.payload ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const renderGridCell = (data) => {
    let editLink = (
      <a
        href="#"
        title="Edit"
        style={{ cursor: "pointer !important" }}
        onClick={(e) => {
          e.preventDefault();
          try {
            setState((prev) => ({
              ...prev,
              isSaveHotelTransferContractModalOpen: true,
            }));
            setEditRowData(data?.data);
          } catch (error) {
            console.log(error);
          }
        }}
      >
        <i className="fas fa-edit"></i>
      </a>
    );
    let viewLink = (
      <a
        href="#"
        title="View"
        style={{ paddingLeft: "6px", cursor: "pointer !important" }}
        onClick={(e) => {
          e.preventDefault();
          try {
            setState((prev) => ({
              ...prev,
              isViewHotelTransferContractModalOpen: true,
            }));
            setViewRowData(data?.data);
          } catch (error) {
            console.log(error);
          }
        }}
      >
        <i className="fas fa-eye"></i>
      </a>
    );
    return (
      <div style={{ textAlign: "left" }}>
        {editLink}
        {viewLink}
      </div>
    );
  };

  return (
    <>
      <div className="card">
        <div className="card-body">
          {isLoading && <DataGridSkeletonPageSimple />}
          {!isLoading && (
            <>
              <DataGrid
                keyExpr="id"
                ref={refDataGrid}
                dataSource={hotelTransferContractDataGridSource}
                showBorders={true}
                columnAutoWidth={true}
                allowColumnResizing={true}
                showRowLines={true}
                showColumnLines={true}
                onCellPrepared={(e) => {}}
                onToolbarPreparing={(e) => {
                  e.toolbarOptions.items.unshift(
                    {
                      location: "after",
                      template: "toolbarTemplateAddHotelTransferContract",
                    },
                    {
                      location: "after",
                      widget: "dxButton",
                      options: {
                        icon: "refresh",
                        onClick: async (e) => {
                          try {
                            refDataGrid.current.instance.beginCustomLoading();
                            e.component.option(
                              "icon",
                              "fas fa-spinner fa-spin"
                            );
                            await new Promise((resolve) =>
                              setTimeout(resolve, 500)
                            );
                            await getHotelTransferContract();
                            refDataGrid.current.instance.endCustomLoading();
                            e.component.option("icon", "refresh");
                          } catch (error) {
                            console.log(error);
                          }
                        },
                      },
                    }
                  );
                }}
              >
                <Column
                  dataField="id"
                  caption=""
                  allowSorting={false}
                  allowSearch={false}
                  allowExporting={false}
                  allowFiltering={false}
                  alignment={"left"}
                  width={"60"}
                  fixed={true}
                  cellRender={renderGridCell}
                />
                <Column
                  dataField="airlineCode"
                  caption="Airline"
                  allowFiltering={false}
                  allowSearch={true}
                  alignment={"center"}
                />
                <Column
                  dataField="airportCode"
                  caption="Airport"
                  allowFiltering={false}
                  allowSearch={true}
                  alignment={"center"}
                />
                <Column
                  dataField="hotelCode"
                  caption="Hotel Code"
                  allowFiltering={false}
                  allowSearch={true}
                />
                <Column
                  dataField="hotelName"
                  caption="Hotel Name"
                  allowFiltering={false}
                  allowSearch={true}
                />
                <Column
                  dataField="isProvidingAirportTransfer"
                  caption="Providing Airport Transfer"
                  allowFiltering={false}
                  allowSearch={false}
                />
                <Column
                  dataField="isProvidingActivityLocationTransfer"
                  caption="Providing Activity Location Transfer"
                  allowFiltering={false}
                  allowSearch={false}
                />
                <Column
                  dataField="isProvidingAirportTransferLayover"
                  caption="Providing Airport Transfer Layover"
                  allowFiltering={false}
                  allowSearch={false}
                />
                <Column
                  dataField="wefDate"
                  caption="Wef Date"
                  allowFiltering={true}
                  allowSearch={true}
                  format={DateFormat.DateNorthFormat}
                  dataType="datetime"
                />
                <Column
                  dataField="endDate"
                  caption="End Date"
                  allowFiltering={true}
                  allowSearch={true}
                  format={DateFormat.DateNorthFormat}
                  dataType="datetime"
                />
                <Column
                  dataField="cancelHotelBeforeMinutes"
                  caption=" Cancel Hotel Before Minutes"
                  allowFiltering={true}
                  allowSearch={true}
                  alignment={"center"}
                />
                <Template
                  name="toolbarTemplateAddHotelTransferContract"
                  render={() => {
                    return (
                      <>
                        <button
                          type="submit"
                          className="btn btn-primary"
                          onClick={() => {
                            setState((prev) => ({
                              ...prev,
                              isSaveHotelTransferContractModalOpen: true,
                            }));
                          }}
                        >
                          <span title="Submit">
                            <i className="fas fa-plus"></i>&nbsp;Add
                            Configuration
                          </span>
                        </button>
                      </>
                    );
                  }}
                />
                <HeaderFilter visible={true} />
                <Paging defaultPageSize={20} />
                <Pager
                  showPageSizeSelector={true}
                  allowedPageSizes={[10, 20, 50]}
                  showInfo={true}
                  visible={true}
                />
                <SearchPanel
                  visible={true}
                  highlightCaseSensitive={true}
                  width={240}
                  placeholder="Search..."
                />
                <Export
                  enabled={true}
                  allowExportSelectedData={false}
                  fileName="HotelTransferContract"
                />
              </DataGrid>
            </>
          )}
        </div>
      </div>
      {state.isViewHotelTransferContractModalOpen && (
        <>
          <ViewHotelTransferContractModal
            data={viewRowData}
            close={() => {
              setState((prev) => ({
                ...prev,
                isViewHotelTransferContractModalOpen: false,
              }));
              setViewRowData(null);
            }}
          />
        </>
      )}
      {state.isSaveHotelTransferContractModalOpen && (
        <>
          <SaveHotelTransferContractModal
            data={editRowData}
            refresh={async () => {
              await getHotelTransferContract();
            }}
            close={() => {
              setState((prev) => ({
                ...prev,
                isSaveHotelTransferContractModalOpen: false,
              }));
              setEditRowData(null);
            }}
          />
        </>
      )}
    </>
  );
}

function ViewHotelTransferContractModal(props) {
  const [hotelTransferContractInfo, setHotelTransferContractInfo] =
    useState(null);

  const getHotelTransferContractInfo = async () => {
    try {
      const response = await axiosGet(`/HotelTransferContract/info`, {
        AirlineCode: props?.data?.airlineCode,
        AirportCode: props?.data?.airportCode,
        HotelCode: props?.data?.hotelCode,
      });
      setHotelTransferContractInfo(response?.payload ?? null);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        ariaHideApp={false}
        isOpen={true}
        className={"react-modal custom-modal-large-2"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
        onAfterOpen={async () => {
          await getHotelTransferContractInfo();
        }}
      >
        <div className="modal-header">
          <h6 className="modal-title">
            View Hotel Transfer Contract For - {props?.data?.hotelName}
            &nbsp;-&nbsp;
            {props?.data?.hotelCode}
          </h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              props.close();
              setHotelTransferContractInfo(null);
            }}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
              <div className="form-group">
                <label>Wef Date</label>
                <input
                  type="text"
                  readOnly={true}
                  name="wefDate"
                  className="form-control form-control-sm"
                  value={
                    hotelTransferContractInfo?.hotelTransferContractDetails
                      ?.wefDate
                      ? moment(
                          hotelTransferContractInfo
                            ?.hotelTransferContractDetails?.wefDate
                        ).format(DateFormat.MomentDisplayDateTimeAMPMFullFormat)
                      : ""
                  }
                />
              </div>
            </div>
            <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
              <div className="form-group">
                <label>End Date</label>
                <input
                  type="text"
                  readOnly={true}
                  name="endDate"
                  className="form-control form-control-sm"
                  value={
                    hotelTransferContractInfo?.hotelTransferContractDetails
                      ?.endDate
                      ? moment(
                          hotelTransferContractInfo
                            ?.hotelTransferContractDetails?.endDate
                        ).format(DateFormat.MomentDisplayDateTimeAMPMFullFormat)
                      : ""
                  }
                />
              </div>
            </div>
            <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
              <div className="form-group">
                <label>Airport</label>
                <input
                  type="text"
                  readOnly={true}
                  name="airportCode"
                  className="form-control form-control-sm"
                  value={props?.data?.airportCode}
                />
              </div>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
              <div className="form-group">
                <strong>Hotel Shuttle For Airport Transfer Layover</strong>
                <div>
                  <button
                    type="button"
                    className={
                      !hotelTransferContractInfo?.hotelTransferContractDetails
                        ?.isProvidingAirportTransferLayover
                        ? "btn btn-primary"
                        : "btn btn-outline-secondary"
                    }
                    disabled={true}
                  >
                    <span title="Excluded">
                      <i
                        className={`${
                          !hotelTransferContractInfo
                            ?.hotelTransferContractDetails
                            ?.isProvidingAirportTransferLayover
                            ? "fas fa-check"
                            : ""
                        }`}
                      />
                      &nbsp;&nbsp;Excluded
                    </span>
                  </button>
                  &nbsp;&nbsp;&nbsp;
                  <button
                    type="button"
                    className={
                      hotelTransferContractInfo?.hotelTransferContractDetails
                        ?.isProvidingAirportTransferLayover
                        ? "btn btn-primary"
                        : "btn btn-outline-secondary"
                    }
                    disabled={true}
                  >
                    <span title="Included">
                      <i
                        className={`${
                          hotelTransferContractInfo
                            ?.hotelTransferContractDetails
                            ?.isProvidingAirportTransferLayover
                            ? "fas fa-check"
                            : ""
                        }`}
                      />
                      &nbsp;&nbsp;Included
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div className="from-group">
                <DataGrid
                  dataSource={hotelTransferContractInfo?.airportTransferLst}
                  columnAutoWidth={true}
                  showColumnLines={true}
                  showRowLines={true}
                  showBorders={true}
                  rowAlternationEnabled={false}
                  allowColumnResizing={true}
                  onToolbarPreparing={(e) => {
                    e.toolbarOptions.items.unshift({
                      location: "before",
                      template: "toolbarNameTemplate",
                    });
                  }}
                  height={250}
                >
                  <Column
                    dataField="airportTransferFor"
                    caption="Crew Type"
                    allowSearch={true}
                  />
                  <Column
                    dataField="airportName"
                    caption="Airport"
                    allowSearch={true}
                  />
                  <Column
                    dataField="isAirportProvidingTransfer"
                    caption="Providing Airport Transfer"
                    allowFiltering={false}
                    allowSearch={false}
                  />
                  <Template
                    name="toolbarNameTemplate"
                    render={() => {
                      return (
                        <>
                          <strong>Airport Transfer</strong>
                        </>
                      );
                    }}
                  />
                  <HeaderFilter visible={true} />
                  <Scrolling mode={"virtual"} />
                  <SearchPanel
                    visible={false}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Export
                    enabled={false}
                    allowExportSelectedData={false}
                    fileName="HotelAirportTransfer"
                  />
                </DataGrid>
              </div>
            </div>
            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div className="from-group">
                <DataGrid
                  dataSource={hotelTransferContractInfo?.groundDutyTransfer}
                  columnAutoWidth={true}
                  showColumnLines={true}
                  showRowLines={true}
                  showBorders={true}
                  rowAlternationEnabled={false}
                  allowColumnResizing={true}
                  onToolbarPreparing={(e) => {
                    e.toolbarOptions.items.unshift({
                      location: "before",
                      template: "toolbarNameTemplate",
                    });
                  }}
                  height={250}
                >
                  <Column
                    dataField="groundDutyTransferFor"
                    caption="Crew Type"
                    allowSearch={true}
                  />
                  <Column
                    dataField="locationCode"
                    caption="Location Code"
                    allowSearch={true}
                  />
                  <Column
                    dataField="isGroundDutyProvidingTransfer"
                    caption="Providing Ground Duty Transfer"
                    allowFiltering={false}
                    allowSearch={false}
                  />
                  <Template
                    name="toolbarNameTemplate"
                    render={() => {
                      return (
                        <>
                          <strong>Ground Duty Transfer</strong>
                        </>
                      );
                    }}
                  />
                  <HeaderFilter visible={true} />
                  <Scrolling mode={"virtual"} />
                  <SearchPanel
                    visible={false}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Export
                    enabled={false}
                    allowExportSelectedData={false}
                    fileName="HotelGroundDutyTransfer"
                  />
                </DataGrid>
              </div>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-xs-8 col-sm-8 col-md-8 col-lg-8">
              <div className="form-inline">
                <div className="form-group">
                  <div>&nbsp;</div>
                  <strong
                    style={{
                      fontSize: 1 + "em",
                      fontWeight: "bold !important",
                    }}
                  >
                    Allow crew to cancel hotel stay before&nbsp;
                  </strong>
                  <input
                    type="text"
                    readOnly={true}
                    className="form-control mx-sm-1 form-control-sm"
                    style={{ width: 60 + "px" }}
                    name="cancelHotelBeforeMinutes"
                    width="25px"
                    title="Cancel hotel before minutes"
                    value={
                      Number(
                        hotelTransferContractInfo?.hotelTransferContractDetails
                          ?.cancelHotelBeforeMinutes ?? 0
                      ) || ""
                    }
                  />
                  <small id="" className="text-muted">
                    Minute
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

function SaveHotelTransferContractModal(props) {
  const [state, setState] = useState({
    isSubmitted: false,
    hotelCode: props?.data?.hotelCode ?? "",
    wefDate: props?.data?.wefDate ?? "",
    airportCode: props?.data?.airportCode ?? "",
    isIncludeHotelShuttle:
      props?.data?.isProvidingAirportTransferLayover ?? false,
    cancelHotelBeforeMinutes: props?.data?.cancelHotelBeforeMinutes ?? 0,
  });
  const [errors, setErrors] = useState({
    hotelValidation: "",
    wefDateValidation: "",
    cancelHotelBeforeMinutesValidation: "",
  });
  const [hotelDropdown, setHotelDropdown] = useState([]);
  const [airlineHotelAirportTransferLst, setAirlineHotelAirportTransferLst] =
    useState(props?.data?.airlineHotelAirportTransferLst ?? []);
  const [
    airlineHotelGroundDutyTransferLst,
    setAirlineHotelGroundDutyTransferLst,
  ] = useState(props?.data?.airlineHotelGroundDutyTransferLst ?? []);

  const getHotelDropdown = async () => {
    try {
      const response = await axiosGet(`/Hotel/get-hotel-dropdown`, {
        AirlineCode: sessionStorage.getItem("session_airlineCode"),
      });
      setHotelDropdown(response?.payload ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getAirlineHotelAirportTransfer = async (airportCode, HotelCode) => {
    try {
      const response = await axiosGet(
        `/HotelTransferContract/airport-transfer`,
        {
          AirlineCode: sessionStorage.getItem("session_airlineCode"),
          AirportCode: airportCode,
          HotelCode: HotelCode,
        }
      );
      setAirlineHotelAirportTransferLst(response?.payload ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getAirlineHotelGroundDutyTransfer = async (airportCode, HotelCode) => {
    try {
      const response = await axiosGet(
        `/HotelTransferContract/ground-duty-transfer`,
        {
          AirlineCode: sessionStorage.getItem("session_airlineCode"),
          AirportCode: airportCode,
          HotelCode: HotelCode,
        }
      );
      setAirlineHotelGroundDutyTransferLst(response?.payload ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const handleOnInputChange = (event) => {
    try {
      const target = event.target;
      const name = target.name;
      const value =
        target.type === "checkbox" || target.type === "radio"
          ? target.checked
          : target.value;
      let err = { ...errors };
      switch (name) {
        case "cancelHotelBeforeMinutes":
          err.cancelHotelBeforeMinutesValidation = "";
          if (!value.startsWith(" ") || !value.startsWith(0)) {
            if (value.trim() === "" || RegEx.Numeric.test(value)) {
              if (value.length <= 6) {
                setState((prev) => ({
                  ...prev,
                  cancelHotelBeforeMinutes: value.trim(),
                }));
              }
            }
          }
          break;
        default:
          break;
      }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
  };

  const isValidAddHotelTransferContractData = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      err.wefDateValidation = "";
      err.hotelValidation = "";
      err.cancelHotelBeforeMinutesValidation = "";
      if (!state.wefDate) {
        isValid = false;
        err.wefDateValidation = "Please select wefDate.";
      }
      if (!state.hotelCode) {
        isValid = false;
        err.hotelValidation = "Please select hotel.";
      }
      if (
        Number(state.cancelHotelBeforeMinutes) === 0 ||
        !state.cancelHotelBeforeMinutes
      ) {
        isValid = false;
        err.cancelHotelBeforeMinutesValidation =
          "Before cancelling hotel, please enter minutes.";
      }
      setErrors(err);
    } catch (error) {
      console.log(error);
    }
    return isValid;
  };

  const handleOnAddHotelTransferContract = async (e) => {
    e.preventDefault();
    try {
      if (isValidAddHotelTransferContractData()) {
        let confirmationQuestion = `Are You Sure Want To Save Hotel Transfer Contract?`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        const airlineHotelAirportTransferData =
          airlineHotelAirportTransferLst?.flatMap((item) => {
            const results = [];
            results.push({
              CrewType: "F",
              IsChecked: item.isCabinCrew,
              AirportCode: item.airportCode,
              IsProvidingTransfer: item.isProvidingCabinCrewShuttle,
            });
            results.push({
              CrewType: "P",
              IsChecked: item.isCockpit,
              AirportCode: item.airportCode,
              IsProvidingTransfer: item.isProvidingCockpitShuttle,
            });
            return results;
          });
        const airlineHotelGroundDutyTransferData =
          airlineHotelGroundDutyTransferLst?.flatMap((item) => {
            const results = [];
            results.push({
              CrewType: "F",
              LocationCode: item.locationCode,
              IsChecked: item.isCabinCrew,
              IsProvidingTransfer: item.isProvidingCabinCrewShuttle,
            });
            results.push({
              CrewType: "P",
              LocationCode: item.locationCode,
              IsChecked: item.isCockpit,
              IsProvidingTransfer: item.isProvidingCockpitShuttle,
            });
            return results;
          });
        setState((prev) => ({ ...prev, isSubmitted: true }));
        const response = await axiosPost(`/HotelTransferContract/save`, {
          AirlineCode: sessionStorage.getItem("session_airlineCode"),
          AirportCode: state.airportCode,
          WefDate: state.wefDate
            ? moment(state.wefDate).format(DateFormat.SqlDateFormat)
            : "",
          HotelCode: state.hotelCode,
          AirportCodeLst: airlineHotelAirportTransferData,
          CancelHotelBeforeMinutes: Number(state.cancelHotelBeforeMinutes),
          LocationCodeLst: airlineHotelGroundDutyTransferData,
          IsProvidingAirportTransferLayover: state.isIncludeHotelShuttle,
          UserId: sessionStorage.getItem("session_userId"),
          UserName: sessionStorage.getItem("session_userName"),
        });
        isConfirmed = await showResponseMessage(response);
        setState((prev) => ({ ...prev, isSubmitted: false }));
        if (isConfirmed) {
          if (response?.isSuccess) {
            handleOnCloseHotelTransferContract();
            props.refresh();
          }
        }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isSubmitted: false }));
      console.log(error);
    }
  };

  const handleOnCloseHotelTransferContract = () => {
    try {
      props.close();
      setState((prev) => ({
        ...prev,
        isSubmitted: false,
        hotelCode: "",
        wefDate: "",
        airportCode: "",
        isIncludeHotelShuttle: false,
        cancelHotelBeforeMinutes: 0,
      }));
      setHotelDropdown([]);
      setAirlineHotelAirportTransferLst([]);
      setAirlineHotelGroundDutyTransferLst([]);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        ariaHideApp={false}
        isOpen={true}
        className={"react-modal custom-modal-large-2 "}
        onAfterOpen={async () => {
          await getHotelDropdown();
          let err = { ...errors };
          err.wefDateValidation = "";
          err.cancelHotelBeforeMinutesValidation = "";
          err.hotelValidation = "";
          setErrors(err);
        }}
        shouldCloseOnOverlayClick={false}
        contentLabel="Example Modal"
      >
        <div className="modal-header">
          <h6 className="modal-title">
            {props?.data?.hotelCode
              ? `Update Hotel Transfer Contract For - ${props?.data?.hotelName} - ${props?.data?.hotelCode}`
              : `Add Hotel Transfer Contract`}
          </h6>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              handleOnCloseHotelTransferContract();
            }}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
              <div className="form-group">
                <label>
                  Wef Date&nbsp;<span className="text-danger">*</span>
                </label>
                <DateBox
                  type="date"
                  className="form-control form-control-sm"
                  name="wefDate"
                  placeholder={DateFormat.DateNorthFormat}
                  displayFormat={DateFormat.DateNorthFormat}
                  showAnalogClock={false}
                  useMaskBehavior={false}
                  defaultValue={state.wefDate}
                  value={state.wefDate}
                  readOnly={props?.data?.wefDate}
                  disabled={false}
                  acceptCustomValue={true}
                  onValueChanged={(date) => {
                    let err = { ...errors };
                    err.wefDateValidation = "";
                    setState((prev) => ({
                      ...prev,
                      wefDate: date.value,
                    }));
                    setErrors(err);
                  }}
                />
                {errors.wefDateValidation.length > 0 && (
                  <span className="error invalid-feedback">
                    {errors.wefDateValidation}
                  </span>
                )}
              </div>
            </div>
            <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
              <div className="form-group">
                <label>
                  Hotel&nbsp;<span className="text-danger">*</span>
                </label>
                <SelectBox
                  dataSource={hotelDropdown}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select Hotel"
                  name="hotelDropdown"
                  defaultValue={state.hotelCode}
                  value={state.hotelCode}
                  displayExpr="hotelName"
                  valueExpr="hotelCode"
                  showClearButton={true}
                  searchEnabled={true}
                  disabled={false}
                  readOnly={props?.data?.hotelCode}
                  onSelectionChanged={async (e) => {
                    let err = { ...errors };
                    err.hotelValidation = "";
                    setState((prev) => ({
                      ...prev,
                      hotelCode: e?.selectedItem?.hotelCode ?? "",
                      airportCode: e?.selectedItem?.airportCodes ?? "",
                    }));
                    setErrors(err);
                    setAirlineHotelAirportTransferLst([]);
                    setAirlineHotelGroundDutyTransferLst([]);
                    if (
                      e?.selectedItem?.hotelCode &&
                      e?.selectedItem?.airportCodes
                    ) {
                      await getAirlineHotelAirportTransfer(
                        e?.selectedItem?.airportCodes,
                        e?.selectedItem?.hotelCode
                      );
                      await getAirlineHotelGroundDutyTransfer(
                        e?.selectedItem?.airportCodes,
                        e?.selectedItem?.hotelCode
                      );
                    }
                  }}
                />
                {errors.hotelValidation.length > 0 && (
                  <span className="error invalid-feedback">
                    {errors.hotelValidation}
                  </span>
                )}
              </div>
            </div>
            <div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
              <div className="form-group">
                <label>Airport</label>
                <input
                  type="text"
                  readOnly={true}
                  name="airportCode"
                  className="form-control form-control-sm"
                  value={state.airportCode}
                />
              </div>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-xs-8 col-sm-8 col-md-8 col-lg-8">
              <div className="form-group">
                <strong>Hotel Shuttle For Airport Transfer Layover</strong>
                <div>
                  <button
                    type="button"
                    className={
                      !state.isIncludeHotelShuttle
                        ? "btn btn-primary"
                        : "btn btn-outline-secondary"
                    }
                    onClick={() => {
                      setState((prev) => ({
                        ...prev,
                        isIncludeHotelShuttle: false,
                      }));
                    }}
                  >
                    <span title="Excluded">
                      <i
                        className={`${
                          !state.isIncludeHotelShuttle ? "fas fa-check" : ""
                        }`}
                      />
                      &nbsp;&nbsp;Excluded
                    </span>
                  </button>
                  &nbsp;&nbsp;&nbsp;
                  <button
                    type="button"
                    className={
                      state.isIncludeHotelShuttle
                        ? "btn btn-primary"
                        : "btn btn-outline-secondary"
                    }
                    onClick={() => {
                      setState((prev) => ({
                        ...prev,
                        isIncludeHotelShuttle: true,
                      }));
                    }}
                  >
                    <span title="Included">
                      <i
                        className={`${
                          state.isIncludeHotelShuttle ? "fas fa-check" : ""
                        }`}
                      />
                      &nbsp;&nbsp;Included
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div className="form-group">
                <DataGrid
                  dataSource={airlineHotelAirportTransferLst}
                  columnAutoWidth={true}
                  showColumnLines={true}
                  showRowLines={true}
                  showBorders={true}
                  rowAlternationEnabled={false}
                  allowColumnResizing={true}
                  onToolbarPreparing={(e) => {
                    e.toolbarOptions.items.unshift({
                      location: "before",
                      template: "toolbarNameTemplate",
                    });
                  }}
                  height={200}
                >
                  <Editing
                    mode="cell"
                    allowUpdating={true}
                    allowAdding={false}
                  />
                  <Column
                    dataField="airlineCode"
                    caption="Airline Code"
                    allowSearch={true}
                    allowEditing={false}
                  />
                  <Column
                    dataField="airportCode"
                    caption="Airport Code"
                    allowSearch={true}
                    allowEditing={false}
                  />
                  <Column
                    dataField="airportName"
                    caption="Airport Name"
                    allowSearch={true}
                    allowEditing={false}
                  />
                  <Column
                    dataField="hotelCode"
                    caption="Hotel Code"
                    allowSearch={true}
                    allowEditing={false}
                  />
                  <Column
                    dataField="isCockpit"
                    caption="Cockpit"
                    allowFiltering={false}
                    allowSearch={false}
                    allowExporting={false}
                    allowEditing={true}
                  />
                  <Column
                    dataField="isCabinCrew"
                    caption="CabinCrew"
                    allowFiltering={false}
                    allowSearch={false}
                    allowExporting={false}
                    allowEditing={true}
                  />
                  <Column
                    dataField="isProvidingCockpitShuttle"
                    caption="Providing Cockpit Shuttle"
                    allowFiltering={false}
                    allowSearch={false}
                    allowExporting={false}
                    allowEditing={true}
                  />
                  <Column
                    dataField="isProvidingCabinCrewShuttle"
                    caption="Providing CabinCrew Shuttle"
                    allowFiltering={false}
                    allowSearch={false}
                    allowExporting={false}
                    allowEditing={true}
                  />
                  <Template
                    name="toolbarNameTemplate"
                    render={() => {
                      return (
                        <>
                          <strong>Airline Hotel Airport Transfer</strong>
                        </>
                      );
                    }}
                  />
                  <HeaderFilter visible={true} />
                  <Scrolling mode={"virtual"} />
                  <SearchPanel
                    visible={false}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Export
                    enabled={false}
                    allowExportSelectedData={false}
                    fileName="AirlineHotelAirportTransfer"
                  />
                </DataGrid>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div className="form-group">
                <DataGrid
                  dataSource={airlineHotelGroundDutyTransferLst}
                  columnAutoWidth={true}
                  showColumnLines={true}
                  showRowLines={true}
                  showBorders={true}
                  rowAlternationEnabled={false}
                  allowColumnResizing={true}
                  onToolbarPreparing={(e) => {
                    e.toolbarOptions.items.unshift({
                      location: "before",
                      template: "toolbarNameTemplate",
                    });
                  }}
                  height={200}
                >
                  <Editing
                    mode="cell"
                    allowUpdating={true}
                    allowAdding={false}
                  />
                  <Column
                    dataField="airlineCode"
                    caption="Airline Code"
                    allowSearch={true}
                    allowEditing={false}
                  />
                  <Column
                    dataField="airportCode"
                    caption="Airport Code"
                    allowSearch={true}
                    allowEditing={false}
                  />
                  <Column
                    dataField="locationCode"
                    caption="Location Code"
                    allowSearch={true}
                    allowEditing={false}
                  />
                  <Column
                    dataField="isCockpit"
                    caption="Cockpit"
                    allowFiltering={false}
                    allowSearch={false}
                    allowExporting={false}
                    allowEditing={true}
                  />
                  <Column
                    dataField="isCabinCrew"
                    caption="CabinCrew"
                    allowFiltering={false}
                    allowSearch={false}
                    allowExporting={false}
                    allowEditing={true}
                  />
                  <Column
                    dataField="isProvidingCockpitShuttle"
                    caption="Providing Cockpit Shuttle"
                    allowFiltering={false}
                    allowSearch={false}
                    allowExporting={false}
                    allowEditing={true}
                  />
                  <Column
                    dataField="isProvidingCabinCrewShuttle"
                    caption="Providing CabinCrew Shuttle"
                    allowFiltering={false}
                    allowSearch={false}
                    allowExporting={false}
                    allowEditing={true}
                  />
                  <Template
                    name="toolbarNameTemplate"
                    render={() => {
                      return (
                        <>
                          <strong>Airline Hotel Ground Duty Transfer</strong>
                        </>
                      );
                    }}
                  />
                  <HeaderFilter visible={true} />
                  <Scrolling mode={"virtual"} />
                  <SearchPanel
                    visible={false}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Export
                    enabled={false}
                    allowExportSelectedData={false}
                    fileName="AirlineHotelGroundDutyTransfer"
                  />
                </DataGrid>
              </div>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div className="form-inline">
                <div className="form-group">
                  <strong
                    style={{
                      fontSize: 1 + "em",
                      fontWeight: "bold !important",
                    }}
                  >
                    Allow crew to cancel hotel stay before&nbsp;
                    <span className="text-danger">*</span>
                  </strong>
                  <input
                    type="text"
                    className="form-control mx-sm-1 form-control-sm"
                    style={{ width: 60 + "px" }}
                    name="cancelHotelBeforeMinutes"
                    width="25px"
                    title="Cancel hotel before minutes"
                    value={Number(state.cancelHotelBeforeMinutes ?? 0) || ""}
                    onChange={(event) => {
                      handleOnInputChange(event);
                    }}
                  />
                  <small id="" className="text-muted">
                    Minute
                  </small>
                  {errors.cancelHotelBeforeMinutesValidation.length > 0 && (
                    <span className="error invalid-feedback">
                      {errors.cancelHotelBeforeMinutesValidation}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            title="Submit"
            className="btn btn-primary"
            onClick={async (e) => {
              await handleOnAddHotelTransferContract(e);
            }}
            disabled={state.isSubmitted}
          >
            <i
              className={`fas fa-${
                state.isSubmitted ? "spinner fa-spin" : "check"
              }`}
            />
            &nbsp;&nbsp;Submit
          </button>
          <button
            type="button"
            title="Close"
            className="btn btn-secondary"
            onClick={() => {
              handleOnCloseHotelTransferContract();
            }}
          >
            <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
          </button>
        </div>
      </Modal>
    </>
  );
}
